/* Size guide page: units toggle (whole page), gallery size picker, staggered pages, carousel. No dependencies. */
(function () {
  var KEY = 'zs-units';

  /* ---------- Units ---------- */
  function setUnits(u, remember) {
    document.documentElement.classList.toggle('zs-cm', u === 'cm');
    document.querySelectorAll('[data-zs-units]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-zs-units') === u ? 'true' : 'false');
    });
    if (remember) { try { localStorage.setItem(KEY, u); } catch (e) {} }
  }
  function initUnits(root) {
    root.querySelectorAll('[data-zs-units-group]').forEach(function (g) {
      if (g.dataset.zsReady) return;
      g.dataset.zsReady = '1';
      var remember = g.getAttribute('data-remember') === 'true';
      var start = g.getAttribute('data-default') || 'in';
      if (remember) { try { start = localStorage.getItem(KEY) || start; } catch (e) {} }
      setUnits(start, false);
      g.addEventListener('click', function (ev) {
        var b = ev.target.closest('[data-zs-units]');
        if (b) setUnits(b.getAttribute('data-zs-units'), remember);
      });
    });
  }

  function dots(el, n, on) {
    if (!el) return;
    if (el.children.length !== n) {
      el.innerHTML = '';
      for (var i = 0; i < n; i++) el.appendChild(document.createElement('span'));
    }
    Array.prototype.forEach.call(el.children, function (d, i) { d.classList.toggle('is-on', i === on); });
    el.style.display = n > 1 ? '' : 'none';
  }

  /* ---------- A: staggered pages ---------- */
  function initStag(set) {
    var pages = set.querySelectorAll('.zs-sg-stag__page');
    var prev = set.querySelectorAll('[data-zs-prev]'), next = set.querySelectorAll('[data-zs-next]');
    var label = set.querySelector('[data-zs-page-label]'), dotEl = set.querySelector('.zs-sg-stag__dots');
    var pager = set.querySelector('.zs-sg-pager');
    var n = pages.length, cur = 0;
    function go(i) {
      cur = Math.max(0, Math.min(n - 1, i));
      pages.forEach(function (p, k) { p.classList.toggle('is-active', k === cur); });
      prev.forEach(function (b) { b.disabled = cur === 0; b.hidden = n < 2; });
      next.forEach(function (b) { b.disabled = cur === n - 1; b.hidden = n < 2; });
      if (label) label.textContent = (cur + 1) + ' of ' + n;
      if (pager) pager.style.display = n > 1 ? '' : 'none';
      dots(dotEl, n, cur);
    }
    prev.forEach(function (b) { b.addEventListener('click', function () { go(cur - 1); }); });
    next.forEach(function (b) { b.addEventListener('click', function () { go(cur + 1); }); });
    var x0 = null;
    set.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    set.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1));
    });
    set.zsReset = function () { go(0); };
    go(0);
  }

  /* ---------- B: carousel (native scroll + snap; arrows step one card) ---------- */
  function initCar(set) {
    var track = set.querySelector('.zs-sg-car__track');
    if (!track) return;
    var items = track.children, dotEl = set.querySelector('.zs-sg-dots');
    var prev = set.querySelectorAll('[data-zs-prev]'), next = set.querySelectorAll('[data-zs-next]');
    function step() { return items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : track.clientWidth; }
    function update() {
      var s = step() || 1, max = track.scrollWidth - track.clientWidth;
      var visible = window.matchMedia('(min-width: 750px)').matches ? 4 : 2;
      var positions = Math.max(1, items.length - visible + 1);
      var i = Math.round(track.scrollLeft / s);
      if (track.scrollLeft >= max - 2) i = positions - 1;
      i = Math.max(0, Math.min(positions - 1, i));
      dots(dotEl, positions, i);
      var none = max <= 2;
      prev.forEach(function (b) { b.disabled = track.scrollLeft <= 2; b.hidden = none; });
      next.forEach(function (b) { b.disabled = track.scrollLeft >= max - 2; b.hidden = none; });
    }
    var raf = 0;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    prev.forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); }); });
    next.forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); }); });
    set.zsReset = function () { track.scrollLeft = 0; update(); };
    set.zsUpdate = update;
    update();
  }

  /* ---------- Gallery: size picker ---------- */
  function initGallery(gal) {
    if (gal.dataset.zsReady) return;
    gal.dataset.zsReady = '1';
    var tabs = gal.querySelectorAll('[role="tab"]');
    var sets = gal.querySelectorAll('.zs-sg-gal__set');
    sets.forEach(function (set) {
      if (gal.getAttribute('data-layout') === 'carousel') initCar(set); else initStag(set);
    });
    function pick(size, focus) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-size') === size;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      sets.forEach(function (s) {
        var on = s.getAttribute('data-size') === size;
        s.hidden = !on;
        if (on) {
          s.querySelectorAll('img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; });
          if (s.zsReset) s.zsReset();
        }
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { pick(t.getAttribute('data-size')); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var nt = tabs[(i + d + tabs.length) % tabs.length];
        pick(nt.getAttribute('data-size'), true);
      });
    });
    var start = gal.getAttribute('data-default') || 'S';
    var first = gal.querySelector('[role="tab"][data-size="' + start + '"]') || tabs[0];
    if (first) pick(first.getAttribute('data-size'));
  }

  /* ---------- Sweaters: mobile picture toggle (desktop shows both; CSS ignores is-on there) ---------- */
  function initSwViews(box) {
    if (box.dataset.zsReady) return;
    box.dataset.zsReady = '1';
    var tabs = box.querySelectorAll('[data-zs-sw-view]');
    if (!tabs.length) return;
    function pick(v, focus) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-zs-sw-view') === v;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      box.querySelectorAll('[data-zs-sw-fig]').forEach(function (f) {
        f.classList.toggle('is-on', f.getAttribute('data-zs-sw-fig') === v);
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { pick(t.getAttribute('data-zs-sw-view')); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        pick(tabs[(i + d + tabs.length) % tabs.length].getAttribute('data-zs-sw-view'), true);
      });
    });
  }

  /* ---------- Gallery lightbox: a photo opens full size (uncropped); prev/next stay within its size ---------- */
  var lb = null;
  function chev(d) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"/></svg>'; }
  function buildLightbox() {
    var d = document.createElement('dialog');
    d.className = 'zs-lb';
    d.setAttribute('aria-label', 'Photo');
    d.innerHTML =
      '<div class="zs-lb__stage">' +
        '<img class="zs-lb__img" alt="">' +
        '<div class="zs-lb__bar"><span class="zs-lb__cap"></span><span class="zs-lb__count"></span></div>' +
      '</div>' +
      '<button type="button" class="zs-lb__btn zs-lb__close" data-lb="close">' + chev('M6 6l12 12M18 6L6 18') + '</button>' +
      '<button type="button" class="zs-lb__btn zs-lb__nav zs-lb__nav--prev" data-lb="prev">' + chev('M15 18l-6-6 6-6') + '</button>' +
      '<button type="button" class="zs-lb__btn zs-lb__nav zs-lb__nav--next" data-lb="next">' + chev('M9 18l6-6-6-6') + '</button>';
    document.body.appendChild(d);
    var st = { items: [], i: 0, opener: null };
    var img = d.querySelector('.zs-lb__img'), cap = d.querySelector('.zs-lb__cap'), count = d.querySelector('.zs-lb__count');
    function show(i) {
      var n = st.items.length;
      st.i = (i + n) % n;
      var a = st.items[st.i], thumb = a.querySelector('img');
      img.classList.remove('is-in');
      img.onload = function () { img.classList.add('is-in'); };
      img.src = a.getAttribute('href');
      img.alt = thumb ? thumb.alt : '';
      if (img.complete) img.classList.add('is-in');
      cap.textContent = a.getAttribute('data-zs-caption') || '';
      count.textContent = n > 1 ? (st.i + 1) + ' / ' + n : '';
      d.classList.toggle('is-single', n < 2);
      [st.i - 1, st.i + 1].forEach(function (k) { var x = st.items[(k + n) % n]; if (x) (new Image()).src = x.getAttribute('href'); });
    }
    /* Cleanup runs on every close path (buttons, backdrop, Esc); safe to run twice */
    function cleanup() {
      if (!document.documentElement.classList.contains('zs-lb-open')) return;
      document.documentElement.classList.remove('zs-lb-open');
      img.removeAttribute('src');
      if (st.opener) st.opener.focus({ preventScroll: true });
    }
    function close() { if (d.open) d.close(); d.removeAttribute('open'); cleanup(); }
    d.addEventListener('close', cleanup);
    d.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    d.addEventListener('click', function (e) {
      var b = e.target.closest('[data-lb]');
      if (b) { var a = b.getAttribute('data-lb'); if (a === 'close') close(); else show(st.i + (a === 'next' ? 1 : -1)); return; }
      if (!e.target.closest('.zs-lb__img')) close();
    });
    d.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); show(st.i + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); show(st.i - 1); }
    });
    var x0 = null;
    d.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    d.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40 && st.items.length > 1) show(st.i + (dx < 0 ? 1 : -1));
    });
    return {
      open: function (items, i, opener, labels) {
        st.items = items; st.opener = opener;
        d.querySelector('[data-lb=close]').setAttribute('aria-label', labels.close || 'Close');
        d.querySelector('[data-lb=prev]').setAttribute('aria-label', labels.prev || 'Previous photo');
        d.querySelector('[data-lb=next]').setAttribute('aria-label', labels.next || 'Next photo');
        show(i);
        document.documentElement.classList.add('zs-lb-open');
        if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
        d.querySelector('[data-lb=close]').focus({ preventScroll: true });
      }
    };
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-zs-zoom]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    e.preventDefault();
    var set = a.closest('.zs-sg-gal__set') || document;
    var gal = a.closest('.zs-sg-gallery') || document.body;
    var items = Array.prototype.slice.call(set.querySelectorAll('a[data-zs-zoom]'));
    lb = lb || buildLightbox();
    lb.open(items, Math.max(0, items.indexOf(a)), a, {
      close: gal.getAttribute('data-zs-close'),
      prev: gal.getAttribute('data-zs-prev-label'),
      next: gal.getAttribute('data-zs-next-label')
    });
  });

  function init(root) {
    root = root || document;
    initUnits(root);
    root.querySelectorAll('[data-zs-sw-views]').forEach(initSwViews);
    root.querySelectorAll('.zs-sg-gallery[data-layout]').forEach(initGallery);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
